/**
 * Trasy zarządzania kategoriami dokumentów (PUB-1649).
 *
 * Zakres v1 to WYŁĄCZNIE kategorie firmowe — zarządzanie kategoriami całego biura nie wchodzi
 * w ten etap. Kategorie systemowe są widoczne, ale tylko do odczytu.
 */
export const DOCUMENT_CATEGORIES_ROUTES = {
  DOCUMENT_CATEGORIES_LIST: {
    path: '/admin/templates/document-categories',
    name: 'document-categories',
  },
};
